import { render, staticRenderFns } from "./ViewFile.vue?vue&type=template&id=1d290511&"
import script from "./ViewFile.vue?vue&type=script&lang=js&"
export * from "./ViewFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d290511')) {
      api.createRecord('1d290511', component.options)
    } else {
      api.reload('1d290511', component.options)
    }
    module.hot.accept("./ViewFile.vue?vue&type=template&id=1d290511&", function () {
      api.rerender('1d290511', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/welfare/mixins/ViewFile.vue"
export default component.exports